import Swiper from 'swiper';
import HtmlElement from './HtmlElement';

/**
 * Swiper Slider
 *
 * @return SwiperSlider
 */
const SwiperSlider = (() => {
	/**
	 * Selector
	 *
	 * @var { Object }
	 */
	const Selector = {
		CONTAINER: '.swiper-container',
		WRAPPER: '.swiper-wrapper',
		SLIDE: '.swiper-slide',
		PAGINATION: '.swiper-pagination'
	};

	/**
	 * Class Name
	 *
	 * @var { Object }
	 */
	const ClassName = {
		INITIALIZED: 'swiper-initialized'
	};

	/**
	 * Swiper Slider
	 *
	 * @class
	 * @augments HtmlElement
	 */
	class SwiperSlider extends HtmlElement {

		/**
		 * @constructor
		 */
		constructor($element) {
			super($element);
			this.slider = null;

			this.length = 0;
			this._defaults = {
				watchOverflow: true,
				on: {
					init: () => {
						this.$element.addClass(ClassName.INITIALIZED);
						this.length = this.$element.find(Selector.SLIDE).length;

						if (this.$element.is('[data-equalizer]')) {
							new Foundation.Equalizer(this.$element).applyHeight();
						}
					}
				}
			};
		}

		// Public

		/**
		 * Handles ready event
		 *
		 * @return void
		 */
		onReady() {
			this.setOptions();
		}

		/**
		 * Sets the options for the slider
		 *
		 * @param { Object } options
		 * @return void
		 */
		setOptions(options = {}) {
			this._options = {
				...this._defaults,
				...options
			};
		}

		// Private

		/**
		 * Initializes the slider
		 *
		 * @return void
		 */
		_initialize() {
			this.slider = new Swiper(this.$element, this._options);
		}

		// Getters

		/**
		 * Returns the Selector constant
		 *
		 * @return { Object } Selector
		 */
		static get Selector() {
			return Selector;
		}

		/**
		 * Returns the ClassName constant
		 *
		 * @return { Object } ClassName
		 */
		static get ClassName() {
			return ClassName;
		}
	}

	return SwiperSlider;
})();

export default SwiperSlider;
